import { useMemo } from 'react';
import type { Candle, UTBotConfig } from '@arc/shared';
import { runUTBot, resolveUTBotSettings, DEFAULT_UTBOT_CONFIG, type UTBotResult } from '@arc/shared';

/**
 * useUTBot — memoized UT Bot calculation that re-runs only when
 * candles or config actually change.
 */
export function useUTBot(
  candles: Candle[],
  config: UTBotConfig,
  symbol: string
): UTBotResult {
  return useMemo(
    // Same fallback for blank/invalid inputs as the server's signal scan
    () => runUTBot(candles, { ...config, ...resolveUTBotSettings(config.keyValue, config.atrPeriod, DEFAULT_UTBOT_CONFIG) }, symbol),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [candles, config.keyValue, config.atrPeriod, config.timeframe, symbol]
  );
}
